(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("click", (event) => {
  const button = event.target.closest(".suvira-announcement-pause");
  if (!button) return;
  const slider = button.closest("announcement-bar-component");
  if (!slider || typeof slider.pause !== "function") return;
  const paused = button.getAttribute("aria-pressed") !== "true";
  if (paused) slider.pause(); else slider.play();
  button.setAttribute("aria-pressed", String(paused));
  button.setAttribute("aria-label", paused ? button.dataset.playLabel : button.dataset.pauseLabel);
  button.textContent = paused ? "▶" : "Ⅱ";
});
const suviraRespectMotion = () => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    document.querySelectorAll("announcement-bar-component").forEach((slider) => {
      slider.removeAttribute("autoplay");
      if (typeof slider.pause === "function") slider.pause();
    });
  }
};
customElements.whenDefined("announcement-bar-component").then(suviraRespectMotion);
document.addEventListener("shopify:section:load", suviraRespectMotion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suvira-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('suvira-photo-slider')) {
  customElements.define('suvira-photo-slider', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.suvira-photos__viewport');
      this.slides = Array.from(this.querySelectorAll('.suvira-photos__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-slide]'));
      this.playback = this.querySelector('[data-playback]');
      this.current = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-direction')) this.go(this.current + Number(button.dataset.direction));
        if (button.hasAttribute('data-slide')) this.go(Number(button.dataset.slide));
        if (button.hasAttribute('data-playback')) {
          this.paused = !this.paused;
          this.updatePlayback();
        }
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.go(this.current + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.viewport.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          this.current = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
          this.update();
        }, 120);
      }, options);
      this.resize = new ResizeObserver(() => this.viewport.scrollTo({ left: this.current * this.viewport.clientWidth, behavior: 'instant' }));
      this.resize.observe(this.viewport);
      this.timer = setInterval(() => {
        if (!this.paused && !this.motion.matches && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) this.go(this.current + 1);
      }, 6000);
      this.update();
      this.updatePlayback();
    }
    go(index) {
      if (!this.slides.length) return;
      this.current = (index + this.slides.length) % this.slides.length;
      this.viewport.scrollTo({ left: this.current * this.viewport.clientWidth, behavior: this.motion.matches ? 'instant' : 'smooth' });
      this.update();
    }
    update() {
      this.slides.forEach((slide, i) => {
        slide.inert = i !== this.current;
        slide.setAttribute('aria-hidden', String(i !== this.current));
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.current)));
    }
    updatePlayback() {
      if (!this.playback) return;
      this.playback.setAttribute('aria-pressed', String(this.paused));
      this.playback.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
      this.playback.textContent = this.paused ? '▶' : 'Ⅱ';
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      clearTimeout(this.scrollTimer);
      this.resize?.disconnect();
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
